import Vue from 'vue'

import 'normalize.css/normalize.css'

import '@/styles/index.less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router/index'
import store from './store/index'

import Waves from '@/directive/waves'
import * as filters from './filters' // global filters

import * as echarts from 'echarts'

import global from '@/global/global.js'

Vue.prototype.$echarts = echarts
Vue.prototype.global = global

ElementUI.Dialog.props.closeOnClickModal.default = false;
// Vue.config.productionTip = false;

Vue.use(Waves)
Vue.use(ElementUI)
// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
